const KEY = "matchbase_verified_user_v1";
export const OFFLINE_AUTH_MAX_AGE_MS = 12 * 60 * 60 * 1000;

export function writeVerifiedUser(storage, user, now = Date.now()) {
  if (!storage || !user?.id) return;
  storage.setItem(KEY, JSON.stringify({ verified_at: now, user }));
}

export function readVerifiedUser(storage, now = Date.now()) {
  if (!storage) return null;
  try {
    const cached = JSON.parse(storage.getItem(KEY) || "null");
    if (!cached?.user?.id || !Number.isFinite(cached.verified_at)) return null;
    if (now - cached.verified_at < 0 || now - cached.verified_at > OFFLINE_AUTH_MAX_AGE_MS) return null;
    return cached.user;
  } catch {
    return null;
  }
}

export function clearVerifiedUser(storage) {
  storage?.removeItem(KEY);
}
